<!-- Don't use this directly, use IconTvDecoder instead. -->

<template>
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <path
      d="M4.6,14.8v4.6c0,1,0.8,1.8,1.9,1.8l1.9,0l0,1.9h7.4v-1.9l1.9,0c1,0,1.9-0.8,1.9-1.9V2.7c0-1-0.8-1.9-1.9-1.9H6.4 c-1,0-1.9,0.8-1.9,1.9v4.6 M6.6,19.1V3h10.7v16.1H6.6z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconTvPortrait',
};
</script>

<style scoped>
svg {
  fill: currentColor;
  max-width: 24px;
  max-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/IconTvPortrait.vue